import { Button } from "primereact/button"
import { JVInput } from "../../shared/JVInput"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Dialog } from "primereact/dialog";
import { Fetch } from "../../shared/Fetch";
import { useEffect } from "react";

interface IProps {
    open: boolean,
    hideDialog: () => void,
    singleData: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    toast?: any,
}

const schema = yup.object({
    months: yup.number().required('Please enter months'),
    inc_Cal_Day: yup.number().required('Please enter day').min(1, 'Day must be greater than 0').max(28, 'Day must be less than 29'),
    branch_Inc_Cal_Day: yup.number().required('Please enter day').min(1, 'Day must be greater than 0').max(28, 'Day must be less than 29')
});


export interface IIncentiveSetting {
    months?: number,
    inc_Cal_Day?: number,
    branch_Inc_Cal_Day?: number,
}

export const Form = (props: IProps) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IIncentiveSetting>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onSubmit = async (data: any) => {
        const method: any = props.singleData.id ? "PUT" : "POST";
        const message: string = props.singleData.id ? "Updated Successfully" : "Added Successfully";
        const url: string = props.singleData.id ? `updateIncentiveSetting` : "addIncentiveSetting";
        const response = await Fetch(`Website_Settings/${url}`, method, data, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            onHide();
        }
    };

    const onHide = () => {
        reset({ months: 0 });
        props.hideDialog();
    };

    useEffect(() => {
        if (props.open) {
            reset(props.singleData);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Incentive Setting" modal className="p-fluid" onHide={onHide}>

            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput column={2} required label="No of months who's incentive is to be calculated" control={control} name="months" error={errors.months?.message} />
                <JVInput column={2} required label="Day on which User Incentive to be Calculated" placeholder="Enter Day (eg: 1 or 25) (must be greater than 0 and less than 29)" control={control} name="inc_Cal_Day" error={errors.inc_Cal_Day?.message} />
                <JVInput column={2} required label="Day on which Branch Incentive to be Calculated" placeholder="Enter Day (eg: 1 or 25) (must be greater than 0 and less than 29)" control={control} name="branch_Inc_Cal_Day" error={errors.branch_Inc_Cal_Day?.message} />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    )
}